import { library } from '@fortawesome/fontawesome-svg-core';
import { faMoneyBillAlt, faBuilding, faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { faCaretRight, faChild, faMale, faHandPaper, faBolt } from '@fortawesome/pro-solid-svg-icons';

library.add(
  faMoneyBillAlt,
  faBuilding,
  faCaretRight,
  faChild,
  faMale,
  faHandPaper,
  faBolt,
  faArrowRight
);



// WEBPACK FOOTER //
// ./src/icons.js